import { BC_TYPE } from '../constant';
import { returnSharedFields } from './shared-fields';

export const batchUpdateFilterFields = ({ t, workflowStepOptions = [], setDisableButton }) => [
  {
    label: t('WORKFLOW_STEP'),
    id: 'WorkflowStep',
    options: workflowStepOptions,
    type: 'select',
    fieldProps: {
      placeholder: true,
      InputLabelProps: { shrink: false },
      onFocus: () => {
        const step = document.querySelector('input[name="WorkflowStep"]');
        if (step.value) {
          setDisableButton(false);
        } else {
          setDisableButton(true);
        }
      },
      onClear: () => {
        setDisableButton(true);
      }
    }
  }
];
export const moduleFilterFields = ({ t, rfidOptions = [], serialNoOptions = [] }) => [
  {
    label: t('RFID_TAG_NO'),
    id: 'RfidtagNo'
    // fieldProps: {
    //   onChange: () => {
    //     const tagNo = document.querySelector('#RfidtagNo');
    //     const serialNo = document.querySelector('#SerialNo');

    //     // if (tagNo.value || serialNo.value) {
    //     //   document.querySelector('#multi-filter-submit-button').classList.remove('Mui-disabled');
    //     //   document.querySelector('#multi-filter-submit-button').disabled = false;
    //     // } else {
    //     //   document.querySelector('#multi-filter-submit-button').classList.add('Mui-disabled');
    //     //   document.querySelector('#multi-filter-submit-button').disabled = true;
    //     // }
    //   }
    // }
  },
  {
    label: t('SERIAL_NO'),
    id: 'SerialNo'
    // fieldProps: {
    //   onChange: () => {
    //     const tagNo = document.querySelector('#RfidtagNo');
    //     const serialNo = document.querySelector('#SerialNo');

    //     // if (tagNo.value || serialNo.value) {
    //     //   document.querySelector('#multi-filter-submit-button').classList.remove('Mui-disabled');
    //     //   document.querySelector('#multi-filter-submit-button').disabled = false;
    //     // } else {
    //     //   document.querySelector('#multi-filter-submit-button').classList.add('Mui-disabled');
    //     //   document.querySelector('#multi-filter-submit-button').disabled = true;
    //     // }
    //   }
    // }
  }
];

export const moduleDetailsFields = ({ t, type, upperCaseLang }) => {
  const {
    cate,
    manufacturer,
    manufacturerAddress,
    concreteGrade,
    asn,
    rfidTagNo,
    tagId,
    serialNo,
    manuDate,
    rsCompany,
    rsinspectionDate,
    castingDate,
    deliveryDate,
    batchNo,
    arrivalDate,
    installDate,
    block,
    floorNo,
    unit,
    subCate,
    hingeSupplier,
    chipFailureSA,
    chipFailureSI,
    firstCastingDate,
    secondCastingDate,
    waterproofInstallDate,
    roomInput,
    gpsDeviceId,
    licensePlateNo,

    dispose,
    productNo,
    contractDesc,
    contractNo,
    contractor,
    bcType
  } = returnSharedFields(t, null, upperCaseLang);

  const unitLabel = {
    ...unit,
    id: 'RoomNo'
  };

  const boolChipFailureSA = {
    ...chipFailureSA,
    isBoolean: true
  };
  const boolChipFailureSI = {
    ...chipFailureSI,
    isBoolean: true
  };
  const boolDispose = {
    ...dispose,
    isBoolean: true
  };

  switch (type) {
    case BC_TYPE.PCF:
    case BC_TYPE.MIC:
    case BC_TYPE.VPB:
    case BC_TYPE.VPK:
      return [
        contractDesc,
        contractNo,
        contractor,
        tagId,
        bcType,
        rfidTagNo,
        manufacturer,
        manufacturerAddress,
        cate,
        concreteGrade,
        asn,
        serialNo,
        productNo,
        manuDate,
        rsCompany,
        // gpsDeviceId,
        licensePlateNo,
        { ...batchNo, label: t('T_PLATE_NO') },

        rsinspectionDate,
        castingDate,
        secondCastingDate,
        deliveryDate,
        arrivalDate,
        installDate,
        block,
        floorNo,
        unitLabel,
        roomInput,
        boolDispose
      ];
    case BC_TYPE.ALW:
      return [
        contractDesc,
        contractNo,
        contractor,
        tagId,
        bcType,
        rfidTagNo,
        manufacturer,
        manufacturerAddress,
        cate,
        subCate,
        hingeSupplier,
        asn,
        serialNo,
        manuDate,
        deliveryDate,
        batchNo,
        arrivalDate,
        boolChipFailureSA,
        installDate,
        block,
        floorNo,
        unitLabel,
        roomInput,
        boolChipFailureSI,
        boolDispose
      ];
    case BC_TYPE.MEG:
    case BC_TYPE.TID:
    case BC_TYPE.STA: 
      return [
        contractDesc,
        contractNo,
        contractor,
        tagId,
        bcType,
        rfidTagNo,
        manufacturer,
        manufacturerAddress,
        cate,
        asn,
        serialNo,
        manuDate,
        deliveryDate,
        batchNo,
        arrivalDate,
        boolChipFailureSA,
        installDate,
        block,
        floorNo,
        unitLabel,
        roomInput,
        boolChipFailureSI,
        boolDispose
      ];
    default:
      return [];
  }
};
